import React from "react";
import { Link } from "react-router-dom";
import DefaultData from "../../CompanyData/DefaultData"; // Adjust the path if DefaultData.js is located elsewhere

const AdminTabs = (props) => {
  const baseTabStyle = {
    border: "none",
    fontWeight: "500",
    padding: "0.75rem 1.5rem",
    borderRadius: "0.375rem 0.375rem 0 0",
  };
  const inactiveTabStyle = {
    ...baseTabStyle,
    backgroundColor: "transparent",
    color: DefaultData.THEMECOLOR3,
    opacity: 2,
  };
  const activeTabStyle = {
    ...baseTabStyle,
    backgroundColor: DefaultData.THEMECOLOR2,
    color: DefaultData.THEMECOLOR3,
  };
  const getStyle = (pageName) =>
    props.pageName === pageName ? activeTabStyle : inactiveTabStyle;

  return (
    <div
      style={{
        backgroundColor: DefaultData.THEMECOLOR5,
        padding: "0 1rem",
        borderBottom: `1px solid ${DefaultData.THEMECOLOR2}`,
      }}
    >
      <ul className="nav nav-tabs" style={{ borderBottom: "none" }}>
        <li className="nav-item">
          <Link
            to={"/company/clients"}
            className="nav-link"
            style={getStyle("CLIENTS")}
          >
            CLIENTS
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to={"/company/suppliers"}
            className="nav-link"
            style={getStyle("SUPPLIERCOMPANIES")}
          >
            SUPPLIERS
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to={"/company/agents"}
            className="nav-link"
            style={getStyle("AGENTS")}
          >
            AGENTS
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to={"/clientwallet"}
            className="nav-link"
            style={getStyle("CLIENTWALLET")}
          >
            CLIENT WALLET
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to={"/agentwallet"}
            className="nav-link"
            style={getStyle("AGENTWALLET")}
          >
            AGENT WALLET
          </Link>
        </li>

        <li className="nav-item">
          <Link
            to={"/visaprices"}
            className="nav-link"
            style={getStyle("PRICES")}
          >
            SUPPLIERS VISA PRICES
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to={"/client/visarequests"}
            className="nav-link"
            style={getStyle("CLIENT VISA REQUESTS")}
          >
            CLIENTS VISA REQUESTS
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/accounttypes"}
            className="nav-link"
            style={getStyle("ACCOUNTTYPES")}
          >
            ACCOUNT TYPES
          </Link>
        </li>

        <li className="nav-item" role="presentation">
          <Link
            to={"/accounts"}
            className="nav-link"
            style={getStyle("ACCOUNTS")}
          >
            ACCOUNTS
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link to={"/items"} className="nav-link" style={getStyle("ITEMS")}>
            ITEMS
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/accountitems"}
            className="nav-link"
            style={getStyle("ACCOUNTITEMS")}
          >
            ACCOUNT ITEMS
          </Link>
        </li>
        <li className="nav-item" role="presentation">
          <Link
            to={"/visamaster"}
            className="nav-link"
            style={getStyle("VISAMASTER")}
          >
            Visa Master
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default AdminTabs;
